import {Component, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { CustomLoaderService } from './custom-loader.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AbwConfirmDialogService } from '../abw-confirm-dialog/abw-confirm-dialog.service';

@Component({
    selector: 'abw-custom-loader',
    templateUrl: './custom-loader.component.html',
    styleUrls: ['./custom-loader.component.scss']
})
export class CustomLoaderComponent implements OnInit, OnDestroy {
    isShown = false;
    message = 'Veuillez patienter...';
    showProgress = false;
    onComplete = new Subject();

    constructor(
        public customLoaderService: CustomLoaderService,
        private _cdf: ChangeDetectorRef,
        private _confirmDialogService: AbwConfirmDialogService
    ) {
    }

    ngOnInit() {
        this.customLoaderService.loaderStatus$.pipe(takeUntil(this.onComplete)).subscribe(_loaderStatus => {
            this.isShown = _loaderStatus.status;
            this.message = _loaderStatus.message;
            this.showProgress = _loaderStatus.showProgress;
            this._cdf.detectChanges();
        });
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }

    async onCancel() {
        const confirmation = await this._confirmDialogService.showConfirmDialog('Abworkflow', 'Voulez-vous vraiment annuler l\'action en cours ?');
        if (confirmation === true && !!this.customLoaderService.cancelCallbackFn) {
            this.customLoaderService.cancelCallbackFn();
        }
    }
}